export default "__VITE_ASSET__3qyNgA6M__"